import { Injectable } from '@angular/core';
import { ITask } from 'shared';

import { TaskAssignmentBaseSocketEventHandler } from './task-assignment-base.se-handler';

interface TaskUnassignedSocketEvent {
    eventDtoType: 'TaskUnassigned';
    task: ITask;
}

@Injectable({ providedIn: 'root' })
export class TaskUnassignedSocketEventHandler extends TaskAssignmentBaseSocketEventHandler<TaskUnassignedSocketEvent> {
    protected eventDtoType(): string {
        return 'TaskUnassigned';
    }

    protected async handleEvent(event: TaskUnassignedSocketEvent): Promise<void> {
        await this.ensureLocalState(event);
    }
}
